import {
  GET_LEAD_PROFILE_STICKY_COLUMNS,
  GET_LEAD_PROFILE_STICKY_COLUMNS_SUCCESS,
  GET_LEAD_PROFILE_STICKY_COLUMNS_ERROR,
  UPDATE_LEAD_PROFILE_STICKY_COLUMNS,
  UPDATE_LEAD_PROFILE_STICKY_COLUMNS_SUCCESS,
  UPDATE_LEAD_PROFILE_STICKY_COLUMNS_ERROR
} from "./actionTypes"

export const getLeadProfileStickyColumns = () => {
  return {
    type: GET_LEAD_PROFILE_STICKY_COLUMNS,
  }
}

export const getLeadProfileStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_LEAD_PROFILE_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getLeadProfileStickyColumnsError = error => {
  return {
    type: GET_LEAD_PROFILE_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

export const updateLeadProfileStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_LEAD_PROFILE_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateLeadProfileStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_LEAD_PROFILE_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateLeadProfileStickyColumnsError = error => {
  return {
    type: UPDATE_LEAD_PROFILE_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}